import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface AllocateAssistTrucksProps {
    scheduleId: number;
    truckId: number;
    truck: string;
    siteAddress: string;
    jobs: ScheduleJob[];
    truckOptions: TruckListOption[];
    availTruckOptions: TruckListOption[];
    assistingTrucks: TruckListOption[];
    showModal: boolean;
    hideModal(): void;
    updateData(jobs: ScheduleJob[]): void;
    updateAvailTruckOptions(availTruckOptions: TruckListOption[]): void;
    updateAssistingTrucks(assistingTrucks: TruckListOption[]): void;
    save(): void;
}

interface AllocateAssistTrucks {
    truckAssistId: number;
    errors: any;
    loading: boolean;
}

interface ScheduleJob {
    id: number;     //schedule id of the item we are editing
    selected: boolean;
    jobQuoteItemId: number;
    jobId: string;
    siteAddress: string;
    itemId: number;
    item: string;
    itemShortcut: string;
    truck: string;
    truckId: number;
    quantityScheduled: number;
}

interface TruckListOption {
    id: number;
    branchId: number;
    name: string;
    registrationNumber: string;
    scheduleVehicleId: number;
    teamDisplay: string;
    numberTeamMembers: number;
}

export default class AllocateAssistTrucksModal extends React.Component<AllocateAssistTrucksProps, AllocateAssistTrucks> {
    constructor(props: AllocateAssistTrucksProps) {
        super(props);
        this.state = {
            truckAssistId: -1,
            errors: {},
            loading: false
        }
    }

    hideModal = () => {
        this.props.hideModal();
    }

    handleTruckChange = (e: any) => {
        //remove any errors
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors["truckAssistId"];
            this.setState({ errors: errors });
        }

        //add truck to assist list
        var trucks = this.props.truckOptions;
        var truckId = e.target.value;

        //find truck item
        var truck = trucks.find(t => t.id == truckId);
        if (truck) {
            var assistingTrucks = this.props.assistingTrucks;
            assistingTrucks.push(truck);

            this.props.updateAssistingTrucks(assistingTrucks);
        }

        //remove truck from available options
        var availTrucks = this.props.availTruckOptions;
        availTrucks.splice(availTrucks.findIndex(function (i) {
            return i.id == truckId;
        }), 1);

        this.props.updateAvailTruckOptions(availTrucks);
    }

    handleJobCheckboxChange = (index: number, e: any) => {
        //remove any errors
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors["jobs"];
            this.setState({ errors: errors });
        }

        var jobs = this.props.jobs;
        var job = jobs[index];

        var editJob: any = {};
        editJob = job;
        editJob[e.target.name] = e.target.checked;

        this.props.updateData(jobs);
    }

    //remove truck from selected
    removeItem = (truckId: number) => {
        //remove any errors
        var errors = this.state.errors;
        delete errors["truckAssistId"];

        var trucksAssisting = this.props.assistingTrucks;
        trucksAssisting.splice(trucksAssisting.findIndex(function (i) {
            return i.id == truckId;
        }), 1);

        this.addTruckToAvailableTrucks(truckId);

        this.props.updateAssistingTrucks(trucksAssisting);
    }

    addTruckToAvailableTrucks = (truckId: number) => {
        //add the truck id back into the avail truck options
        var availTruckOptions = this.props.availTruckOptions;
        //find truck in all trucks
        var truck = this.props.truckOptions.find(t => t.id === truckId);
        if (truck) {
            availTruckOptions.push(truck);
            this.props.updateAvailTruckOptions(availTruckOptions);
        }
    }

    getTotalTruckPeople = (truckAssist: TruckListOption[]) => {
        var totalPeople = 0;
        for (var i = 0; i < truckAssist.length; i++) {
            totalPeople += truckAssist[i].numberTeamMembers;
        }

        return totalPeople;
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        var jobsSelected = this.props.jobs.filter(j => j.selected);
        if (jobsSelected.length === 0) {
            formIsValid = false;
            errors["jobs"] = "Select at least one job to assist with!";
        }

        var trucksAssisting = this.props.assistingTrucks;
        if (trucksAssisting.length === 0) {
            formIsValid = false;
            errors["truckAssistId"] = "Select at least one truck to assist!";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let jobs = this.props.jobs;
        let availTruckOptions = this.props.availTruckOptions;
        let assistingTrucks = this.props.assistingTrucks;

        return (
            <div className="static-modal">
                <Modal size="lg" show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Send Trucks to Assist</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <span>Send truck/s to assist at {this.props.siteAddress}</span>
                        <label className="input-group" htmlFor="truck">
                            <span className="label">Truck requiring assistance</span>
                            <input type='text' id="truck" name="truck" className='input' value={this.props.truck} disabled></input>
                        </label>

                        <div className="table__margin overflowAuto">
                            <table className="table table__small tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th></th>
                                        <th></th>
                                        <th>Site Address</th>
                                        <th>Item</th>
                                        <th>Orig. Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobs.map((job, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{job.id}</td>
                                            <td className="table__text--align">{index + 1}</td>
                                            <td className="table__text--align">
                                                <input type='checkbox' id="selected" name="selected" className='checkbox' checked={job.selected} onChange={(e) => this.handleJobCheckboxChange(index, e)}></input>
                                            </td>
                                            <td className="table__text--align">{job.siteAddress}</td>
                                            <td className="table__text--align">
                                                <div className="tooltipitem tooltipitem__right">{job.itemShortcut}
                                                    <span className="tooltipitemtext tooltipitemtext__right">{job.item}</span>
                                                </div>
                                            </td>
                                            <td className="table__text--align">{job.quantityScheduled}</td>
                                        </tr>

                                    )}
                                </tbody>
                            </table>
                        </div>
                        <span className="label errors">{this.state.errors["jobs"]}</span>

                        <div>
                            <label className="input-group" htmlFor="truckAssistId">
                                <span className="label">Truck/s Assisting</span>
                                <select className="select" id="truckAssistId" name="truckAssistId" value={this.state.truckAssistId} onChange={(e) => this.handleTruckChange(e)}>
                                    <option defaultValue="-1"></option>
                                    {availTruckOptions.map(truck =>
                                        <option key={truck.id} value={truck.id}>{truck.name}-{truck.registrationNumber}</option>
                                    )};
                                </select>
                            </label>
                            <span className="label errors">{this.state.errors["truckAssistId"]}</span>

                            {assistingTrucks.map(truck =>
                                <div key={truck.id}>
                                    <div className="input-group-parent">
                                        <label className="input-group" htmlFor="truckName">
                                            <span className="label">Truck </span>
                                            <span className="input">{truck.name}</span>
                                            <button type="button" className="close makeitred" onClick={() => this.removeItem(truck.id)} >&times;</button>
                                        </label>
                                    </div>
                                </div>
                            )}
                        </div>                
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

}